<template>
  <div>
    <div>
      <span class="xbed-sub-title">{{title}}</span>
    </div>

    <div class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem href="/">丽家会</BreadcrumbItem>
        <BreadcrumbItem>{{title}}</BreadcrumbItem>
      </Breadcrumb>
    </div>
    <section class="add-wrapper">
      <Button type="primary" @click="openTrainingContentModal('create')">添加培训内容</Button>
    </section>

    <!-- 问题 -->
    <!-- edit 报错undefind 'id' -->
    <!-- delete 删除后,行不会自动删除，必须刷新后才消失 -->

    <Table border :columns="columns" :data="tableData"></Table>

    <section style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page show-sizer :total="count" :current="page" @on-change="changePage" @on-page-size-change="changePageSize"></Page>
      </div>
    </section>

    <Modal v-model="addModal.display" ref="trainingListModal" :loading="modalLoading" :title="addModal.title" @on-ok="prepareAddTrainingContent" @on-cancel="cancelAddTrainingContent">
      <Form :model="addModal.data" ref="addTrainingContentForm" :rules="contentFormRules" :label-width="90">
        <FormItem label="培训内容名称" prop="trainingName">
          <Input v-model="addModal.data.trainingName" placeholder="请输入培训内容名称"></Input>
        </FormItem>

        <FormItem label="网址链接" prop="contentUrl">
          <Input v-model="addModal.data.contentUrl" placeholder="请输入网址链接"></Input>
        </FormItem>

        <FormItem label="培训模块" prop="trainingModule">
          <RadioGroup v-model="addModal.data.trainingModule">
            <Radio v-bind:label='1'>
              <span>基础学习</span>
            </Radio>
            <Radio v-bind:label='2'>
              <span>进阶学习</span>
            </Radio>
          </RadioGroup>
        </FormItem>

        <FormItem label="培训主题" prop="trainingItem">
          <RadioGroup v-model="addModal.data.trainingItem">
            <Radio v-bind:label='1' v-show="addModal.data.trainingModule === 1">
              <span>技能学习</span>
            </Radio>
            <Radio v-bind:label='2' v-show="addModal.data.trainingModule === 1">
              <span>平台规则学习</span>
            </Radio>
            <Radio v-bind:label='3' v-show="addModal.data.trainingModule === 1">
              <span>对客话术学习</span>
            </Radio>
            <Radio v-bind:label='4' v-show="addModal.data.trainingModule === 2">
              <span>星级技能学习</span>
            </Radio>
          </RadioGroup>
        </FormItem>

        <FormItem label="权重值：" prop="sortNum">
          <InputNumber :max="500" :min="0" v-model="addModal.data.sortNum"></InputNumber>
        </FormItem>

        <FormItem label="显示状态" prop="displayState">
          <RadioGroup v-model="addModal.data.displayState">
            <Radio v-bind:label='1'>
              <span>显示</span>
            </Radio>
            <Radio v-bind:label='0'>
              <span>隐藏</span>
            </Radio>
          </RadioGroup>
        </FormItem>

      </Form>
      <hr>
      <img style="width:100%" :src="addModal.data.coverUrl" alt="">
      <Upload action="//upload.qiniup.com" name="file" :data="uploadData.form" :before-upload="beforeUpload" :on-success="uploadSuccess" :show-upload-list=false>
        <Button type="primary" icon="ios-cloud-upload-outline">上传封面图</Button>
      </Upload>
    </Modal>

  </div>
</template>

<script>
import Utils from "../../utils";
import API from "../../api";

export default {
  async created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.username = Utils.findFromLocalStorage("vue-username");
    this.env = Utils.findFromLocalStorage("env", "dev");
  },
  async mounted() {
    this.query();
    this.$Notice.config({
      top: 100
    });
  },
  data() {
    return {
      title: "线上培训内容管理",
      tableData: [],
      columns: [
        {
          title: "id",
          key: "id",
          align: "center",
          width: 100
        },
        {
          title: "培训内容名称",
          key: "trainingName",
          align: "center",
          width: 100
        },
        {
          title: "内容网址链接",
          key: "contentUrl",
          align: "center",
          width: 100
        },
        {
          title: "图片链接",
          key: "coverUrl",
          align: "center",
          width: 300,
          render: (h, params) => {
            return h("img", {
              attrs: {
                src: params.row.coverUrl
              },
              style: {
                width: "300px",
                height: "200px"
              }
            });
          }
        },
        {
          title: "培训模块",
          key: "trainingModule",
          align: "center",
          width: 100,
          render: (h, params) => {
            const moduleTypes = ["未知", "基础学习", "进阶学习"];
            return h(
              "div",
              {},
              moduleTypes[
                params.row.trainingModule ? params.row.trainingModule : 0
              ]
            );
          }
        },
        {
          title: "培训主题",
          key: "trainingItem",
          align: "center",
          width: 100,
          render: (h, params) => {
            const itemTypes = ["未知", "技能学习", "平台规则学习", "对客话术学习", "星级技能学习"];
            return h(
              "div",
              {},
              itemTypes[params.row.trainingItem ? params.row.trainingItem : 0]
            );
          }
        },
        {
          title: "权重值",
          key: "sortNum",
          align: "center",
          width: 100
        },
        {
          title: "显示状态",
          key: "displayState",
          width: 200,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const color = row.displayState === 1 ? "green" : "red";
            const text = row.displayState === 1 ? "显示" : "隐藏";
            return h(
              "Tag",
              {
                props: {
                  type: "dot",
                  color: color
                }
              },
              text
            );
          }
        },
        {
          title: "操作",
          width: 150,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "warning",
                    size: "small"
                  },
                  style: {
                    marginRight: "10px"
                  },
                  on: {
                    click: () => {
                      this.edit(params.index);
                    }
                  }
                },
                "修改"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  style: {
                    marginRight: "10px"
                  },
                  on: {
                    click: () => {
                      this.remove(params.row.id, params.index);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      loading: false,
      count: 0,
      pageCount: 0,
      page: 1,
      pageSize: 10,
      uploadData: {
        name: "",
        form: {}
      },
      modalLoading: true,
      contentFormRules: {
        trainingName: [
          { required: true, message: "培训标题不能为空", trigger: "blur" },
          { type: "string", max: 20, message: "培训标题不能超过20字" }
        ],
        contentUrl: [
          { required: true, message: "培训链接不能为空", trigger: "blur" },
          { type: "string", max: 250, message: "培训链接不能超过250字" }
        ],
        sortNum: [
          { required: true, type: "number", message: "请设置权重值", trigger: "blur" }
        ]
      },
      addModal: {
        display: false,
        title: "新增培训内容",
        action: "",
        data: {
          trainingName: "",
          contentUrl: "",
          coverUrl: "",
          trainingModule: 1,
          trainingItem: 1,
          displayState: 1,
          sortNum: 1
        }
      }
    };
  },
  methods: {
    // 添加培训内容
    async prepareAddTrainingContent() {
      this.$refs.addTrainingContentForm.validate(valid => {
        if (valid) {
          this.addTrainingContent();
        } else {
          this.$refs.trainingListModal.buttonLoading = false;
        }
      })
    },
    async addTrainingContent() {
      if (this.addModal.action === "create") {
        if (Object.keys(this.uploadData.form).length == 0) {
          // 错误警告
          this.$Notice.error({
            title: "图片不能为空"
          });
          this.$refs.trainingListModal.buttonLoading = false;
          return;
        }

        let resp = (await API.omsAPI[this.env].cleaner.addTrainContent(
          this.addModal.data,
          this.token
        )).data;

        if (resp.retCode) {
          // 错误警告
          this.$refs.trainingListModal.buttonLoading = false;
          this.$Notice.error({
            title: "添加培训内容失败",
            desc: resp.msg
          });
        } else {
          this.$Notice.success({
            title: "添加培训内容成功"
          });
          this.addModal.display = false;
          this.resetAddModalData();
          this.refreshTable();
        }
      } else if (this.addModal.action === "update") {
        // 修改培训内容
        console.info(this.addModal.data);
        let resp = (await API.omsAPI[this.env].cleaner.editTrainContent(
          this.addModal.data,
          this.token
        )).data;

        if (resp.retCode) {
          // 错误警告
          this.$refs.trainingListModal.buttonLoading = false;
          this.$Notice.error({
            title: "修改培训内容失败",
            desc: resp.msg
          });
        } else {
          this.$Notice.success({
            title: "修改培训内容成功"
          });
          // 手动关闭modal
          this.addModal.display = false;
          // 重置addModal data
          this.resetAddModalData();
          this.refreshTable();
        }
      }
    },
    refreshTable() {
      this.count = 0;
      this.pageCount = 0;
      this.page = 1;
      this.query();
    },
    // 取消添加培训内容
    cancelAddTrainingContent() {
      // 重置addModal data
      this.resetAddModalData();
    },
    resetAddModalData() {
      this.addModal.data = {
        trainingName: "",
        contentUrl: "",
        coverUrl: "",
        trainingModule: 1,
        trainingItem: 1,
        displayState: 1,
        sortNum: 1
      };
    },
    // 编辑培训内容
    async edit(index) {
      let trainContent = this.tableData[index];
      this.addModal.data = {
        id: trainContent.id,
        trainingName: trainContent.trainingName,
        contentUrl: trainContent.contentUrl,
        coverUrl: trainContent.coverUrl,
        trainingModule: trainContent.trainingModule,
        trainingItem: trainContent.trainingItem,
        displayState: trainContent.displayState,
        sortNum: trainContent.sortNum
      };
      this.openTrainingContentModal("update");
    },
    // 删除培训内容
    async remove(id, index) {
      this.$Modal.confirm({
        title: "提示",
        content: "确定删除此培训内容？",
        okText: "确定",
        cancelText: "取消",
        onOk: async () => {
          let resp = (await API.omsAPI[this.env].cleaner.deleteTrainContent(
            id,
            this.token
          )).data;
          if (resp.retCode) {
            this.$Notice.error({
              title: "删除培训内容失败",
              desc: resp.msg
            });
          } else {
            this.$Notice.success({
              title: "删除培训内容成功"
            });
            this.tableData.splice(index, 1);
          }
        }
      });
    },
    changePage(pageIndex) {
      this.page = pageIndex;
      this.query();
    },
    changePageSize(pageSize) {
      this.page = 1;
      this.pageSize = pageSize;
      this.query();
    },
    async query() {
      this.loading = true;
      const resp = (await this.queryTrainingList(this.page, this.pageSize))
        .data;
      if (resp.retCode) {
        // 如果有retCode表示请求有错误
        this.$Notice.error({
          title: "获取培训资料列表失败",
          desc: resp.msg
        });
      } else {
        this.tableData = resp.result;
        this.page = resp.page;
        this.pageSize = resp.pageSize;
        this.pageCount = resp.pageCount;
        this.count = resp.count;
      }
      this.loading = false;
    },
    async openTrainingContentModal(action) {
      this.addModal.display = true;
      if (action === "create") {
        this.addModal.data.createName = this.username;
        this.addModal.action = action;
        this.addModal.title = "新增培训内容";
      }

      if (action === "update") {
        this.addModal.data.updateName = this.username;
        this.addModal.action = action;
        this.addModal.title = "修改培训内容";
      }
    },
    queryTrainingList(page, pageSize) {
      return API.omsAPI[this.env].cleaner.trainContentList(page, pageSize, this.token);
    },
    // 图片上传前
    async beforeUpload(file) {
      console.info(`${file}`);
      let token = (await API.omsAPI[this.env].common.getUploadToken(false, this.token))
        .data;
      this.uploadData.form.token = token;

      // this.advertForm.uploadData.token = token
      this.uploadData.name = `${(Date.now() / 1000) | 0}_${file.name}`;
      this.uploadData.form["x:fileDirId"] = 636;
      this.uploadData.form["x:isPrivate"] = 0;
      this.uploadData.form["x:remark"] = "新增培训图";
      return true;
    },
    uploadSuccess(resp) {
      this.addModal.data.coverUrl = resp.materialBase.url;
    }
  }
};
</script>


<style lang="scss" scoped>
.add-wrapper {
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>




// WEBPACK FOOTER //
// src/pages/cleaner/training-list.vue